import React from 'react';
import { useAppSelector } from '../redux/hooks';
import { selectDirection } from '../redux/selectors';


import logo from '../assets/Xsite.svg'
import errorStyles from './ErrorPage.module.css'
import '../styles/common/animations.css'

const LoadingPage: React.FC = () => {

    const direction = useAppSelector(selectDirection)

    return (
        <div className={errorStyles['error-page']} style={{direction: direction}}>
            <div className="image-wrapper" style={{height: '20vh', width: '20vw'}}>
                <img src={logo} className='pulse-animation' alt='xsite logo'/>
            </div>
        </div>
    );
};

export default LoadingPage;
